module.exports = __webpack_public_path__ + "static/media/my_bg-faded.ea64b459.jpg";